/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';
import { getCartState } from '@msdyn365-commerce/global-state';
import { ProductSearchCriteria, ProductSearchResult } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import { getSimpleProducts, ProductInput } from '@msdyn365-commerce-modules/retail-actions';
import { searchByCriteriaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

/**
 * Input class for activeCartWithProducts data action.
 */
export class UNXProductIdInput implements IActionInput {
    public getCacheKey = () => 'DobbiesUNXReqId';

    public getCacheObjectType = () => 'DobbiesUNXReqId';

    public dataCacheType = (): CacheType => 'request';
}

const createInput = (inputData: ICreateActionContext) => {
    return new UNXProductIdInput();
};

export interface IUNXReqIdState {
    unxReqId?: string;
}

/**
 * Calls the Retail API and returns a cart object based on the passed GetCartInput.
 * @param input
 * @param ctx
 */
export async function updateUNXReqId(input: UNXProductIdInput, ctx: IActionContext): Promise<IUNXReqIdState> {
    return {
        unxReqId: undefined
    };
}

export const updateUNXReqIdAction = createObservableDataAction({
    id: 'dobbies-update-unx-req-id',
    action: <IAction<IUNXReqIdState>>updateUNXReqId,
    input: createInput
});
export default updateUNXReqIdAction;
